import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getSailors, deleteSailor } from '../../../../api/sailor'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { getBoats } from '../../../../api/boat'
import { getRegattas } from '../../../../api/regatta'

function getData(sailors, boats, regattas) {
  let data = []
  for (let i = 0; i < sailors.length; ++i) {
      const elem = {}
      elem.name = sailors[i].fullName
      elem.licence = sailors[i].licence
      elem.mail = sailors[i].mail
      elem.phone = sailors[i].phone
      elem.createdAt = sailors[i].createdAt
      elem.id = sailors[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function SailorsPage() {
  const [data, setData] = useState([])
  const [sailorId, setSailorId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-sailor/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setSailorId(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }


  const columns = [
    { dataField: 'name', text: 'Full name', sort: true },
    { dataField: 'licence', text: 'Licence', sort: true },
    { dataField: 'phone', text: 'Phone number', sort: true },
    { dataField: 'mail', text: 'Email', sort: true },
    {
      dataField: "createdAt",
      text: "Created at",
      formatter: dateFormatter,
      sort: true,
      headerStyle: () => ({ width: "150px" }),
    },
    { dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: () => ({ width: "150px" }), },
  ]

  useEffect(() => {
    getSailors().then((res) => {
      if (res.status === 200) {
        getBoats().then((respBoats) => {
          if (respBoats.status === 200) {
            getRegattas().then((respRegattas) => {
              if (respRegattas.status === 200) {
                setData(getData(res.data, respBoats.data, respRegattas.data))
                setRefresh(false)
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not get regattas.' })
            })
          }
        }).catch(error => {
          alertError({ error: error, customMessage: 'Could not get boats.' })
        })
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get sailors.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Sailors list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-sailor')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this sailor?'}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteSailor(sailorId).then(res => {
                if (res.status === 204) {
                  alertSuccess({  title: 'Deleted!', customMessage: 'Sailor removed successfully.' })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove sailor.' })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
